var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-3" },
    _vm._l(_vm.properties, function(property, index) {
      return _c(
        "v-card-text",
        { key: index, class: index % 2 === 0 ? "pb-0" : "pt-0" },
        [
          _c("summary-value", {
            attrs: { object: _vm.benefits, property: property, small: "" }
          }),
          _vm._v(" "),
          index !== _vm.properties.length - 1
            ? _c("v-divider", { staticClass: "my-4" })
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }